export default "__VITE_ASSET__de7fda64__"